import type { QueryClient } from '@tanstack/react-query';
import type { Backup } from 'shared/types/backups';

import { postgresqlQueryKeys } from '@/enteties/postgresql/api/postgresql.query-keys';

const postgresBackupsHandler = (data: any, queryClient: QueryClient) => {
  const { backupName, status, serviceSlug } = data.payload;
  queryClient.setQueryData<Backup[]>(
    postgresqlQueryKeys.cnpgBackups(serviceSlug),
    (old) => {
      if (!old) return old;
      return old.map((backup) =>
        backup.name === backupName ? { ...backup, status } : backup
      );
    }
  );
};

export { postgresBackupsHandler };
